import React, { useState } from 'react'
import '../assets/css/aboutAndWhy.css'
import QuoteModal from './QuoteModal'
import { useNavigate } from 'react-router-dom';

function AboutAndWhy() {

    const [open, setOpen] = useState(false);
    const navigate = useNavigate()

    return (
        <>
            <section className="about-why-wrapper">
                {/* -------- TOP: WHO WE ARE -------- */}
                <div className="about-card">
                    <div className="about-left">
                        <span className="section-tag">WHO WE ARE</span>

                        <h2>Trusted Resin Manufacturer Delivering Quality Since 2014</h2>

                        <p className="about-desc">
                            At Krishna Chemical & Polymer, we produce high-performance liquid and powder
                            resins designed for plywood, adhesives, molding, and fish-feed
                            industries. Our focus is on consistent quality, reliability, and
                            long-term partnerships.
                        </p>

                        <ul className="about-points">
                            <li>We deliver high-quality resins with strict quality control</li>
                            <li>We support clients with timely supply and technical guidance</li>
                            <li>Trusted by manufacturers across India</li>
                        </ul>

                        <button className="primary-btn" onClick={() => setOpen(true)} style={{ color: '#0f766e', backgroundColor: '#fff' }}>
                            <span className="btn-text-wrap">
                                <span className="btn-text">Get Quote</span>
                                <span className="btn-text btn-text-abs">Get Quote</span>
                            </span>
                        </button>
                    </div>
                </div>

                <QuoteModal isOpen={open} onClose={() => setOpen(false)} />

                {/* -------- BOTTOM: WHY CHOOSE US -------- */}
                <div className="why-section">
                    <span className="section-tag light">WHY CHOOSE US</span>

                    <h2>
                        We Deliver Reliable Quality
                        <br />
                        With Advanced Resin Technology
                    </h2>

                    <div className="why-cards">
                        <div className="why-card">
                            <div className="why-icon">
                                <img src={require('../assets/images/why-sec/factory.png')} alt="" />
                            </div>
                            <h4>Custom Resin Formulations</h4>
                            <p>
                                We manufacture UF, MF, MUF, PF & Binder resins tailored to plywood,
                                adhesive, molding, and fish-feed applications.
                            </p>
                        </div>

                        <div className="why-card">
                            <div className="why-icon">
                                <img src={require('../assets/images/why-sec/manufacturing.png')} alt="" />
                            </div>
                            <h4>Modern Manufacturing Facility</h4>
                            <p>
                                We have team of professionals which can handle problem of end users of Synthetic Resin
                            </p>
                        </div>

                        <div className="why-card">
                            <div className="why-icon">
                                <img src={require('../assets/images/why-sec/location.png')} alt="" />
                            </div>
                            <h4>On-Time Pan-India Delivery</h4>
                            <p>
                                We supply resins across India with reliable logistics and
                                responsive support.
                            </p>
                        </div>
                    </div>

                    <div className="why-stats">
                        <div>
                            <h3>10+</h3>
                            <p>years experience</p>
                        </div>
                        <div>
                            <h3>10+</h3>
                            <p>Resin Variants & Grades</p>
                        </div>
                        <div>
                            <h3>500+</h3>
                            <p>Satisfied Industrial Clients</p>
                        </div>
                        <div>
                            <h3>95%</h3>
                            <p>Repeat Orders & Partnerships</p>
                        </div>
                    </div>

                    <div className="why-btn-wrap">
                        <button class="secondary-btn" style={{ backgroundColor: '#0f766e', color: '#fff' }} onClick={()=>navigate('/about-us')}>
                            <span class="btn-text-wrap">
                                <span class="btn-text">About Us</span>
                                <span class="btn-text btn-text-abs">About Us</span>
                            </span>
                        </button>
                    </div>
                </div>
            </section>
        </>
    )
}

export default AboutAndWhy